import fetch from 'utils/fetch';

export function loginByEmail(phone, password) {
  const data = {
    phone,
    password
  };
  return fetch({
    url: '/auth/token',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    method: 'post',
    data
  });
}

export function logout() {
return fetch({
    url: '/jwt/invalid',
    method: 'post'
});
}

export function getInfo(token) {
  return fetch({
//  url: '/api' +'/admin/api/user/username/' + localStorage.getItem('access-userId'),
//		url:'/api' +'/admin/api/user/un/' + localStorage.getItem('access-userId') + '/permissions',
		url:'/auth/user',
    method: 'get',
    data: token
  });
}

export function getUserType(userId) {
  return fetch({
		url:'api/admin/group/getUserIdSelectRoleType/' + userId,
    method: 'get',
    // data: token
  });
}

//修改密码接口
export function modifyPwd(data) {
  return fetch({
    url:'/api/auth/user/changePassword',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    method: 'post',
    data
  });
}
//修改用戶名
export function modifyUser(data) {
  return fetch({
    url:'/api/auth/user/updateAccountSelective',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    method: 'post',
    data
  });
}

//验证旧密码接口
export function checkPwd(phone, password) {
    const data = {
        phone,
        password
      };
    return fetch({
      url:'/auth/checkPassword',
      headers: {'Content-type': 'application/json;charset=UTF-8'},
      method: 'post',
      data
    });
  }

//重置密码
export function resetPwd(userId) {
    return fetch({
      url:'api/auth/user/resetPassword/'+userId,
      headers: {'Content-type': 'application/json;charset=UTF-8'},
      method: 'get',
    });
  }


  //修改头像
export function modifyAvatar(data) {
    return fetch({
      url:'api/auth/userExtend/alterImg',
      headers: {'Content-type': 'application/json;charset=UTF-8'},
      method: 'post',
      data
    });
  }



// WEBPACK FOOTER //
// ./src/api/login.js